/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_NavigationInputs */

const en_sidebar_navigation = /** @type {(inputs: Sidebar_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigation`)
};

const es_sidebar_navigation = /** @type {(inputs: Sidebar_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegacion`)
};

/**
* | output |
* | --- |
* | "Navigation" |
*
* @param {Sidebar_NavigationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const sidebar_navigation = /** @type {((inputs?: Sidebar_NavigationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_NavigationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sidebar_navigation(inputs)
	return es_sidebar_navigation(inputs)
});